import request from '@/utils/request'
import URL from './urlTranslator'

// 获取首页sop面板业务曲线
export function getWeeklyJobQuantity(params) {
  return request({
    url: `${URL.sys.weeklyJobQuantity}`,
    method: 'get',
    params
  })
}

export function postSopFilterConfig(data) {
  return request({
    url: `${URL.sys.sopFilter}`,
    method: 'post',
    data
  })
}

export function getSopFilterConfig() {
  return request({
    url: `${URL.sys.sopFilter}`,
    method: 'get'
  })
}

export function getSopNodeTree(params) {
  return request({
    url: `${URL.sys.sopNodeTree}`,
    method: 'get',
    params
  })
}

export function getSopNodeInfo(params) {
  return request({
    url: `${URL.sys.sopNodeInfo}`,
    method: 'get',
    params
  })
}

export function getSopNodeInfoByTemplate(params) {
  return request({
    url: `${URL.sys.sopNodeInfoByTemplate}`,
    method: 'get',
    params
  })
}

export function postSopNodeConfig(data) {
  return request({
    url: `${URL.sys.sopNodeConfig}`,
    method: 'post',
    data
  })
}

export function getSopBoardCount(params) {
  return request({
    url: `${URL.sys.sopBoardCount}`,
    method: 'get',
    params
  })
}
export function getSopWaringList(data) {
  return request({
    url: `${URL.sys.sopWaringList}`,
    method: 'post',
    data
  })
}

export function getSopWaringIgnoreList(data) {
  return request({
    url: `${URL.sys.sopWaringIgnoreList}`,
    method: 'post',
    data
  })
}

export function sopWaringOperate(data) {
  return request({
    url: `${URL.sys.sopWaringOperate}`,
    method: 'post',
    data
  })
}

export const getSopWaringNodes = function(data) {
  return request({
    url: `${URL.sys.getSopWaringNodes}`,
    method: 'post',
    data
  })
}
// 获取sop节点或业务类型数量的预警数量
export function queryIndexCount(data) {
  return request({
    url: `${URL.sys.queryIndexCount}`,
    method: 'post',
    data
  })
}
// 获取首页预警列表
export function queryWarningInfoList(data) {
  return request({
    url: `${URL.sys.queryWarningInfoList}`,
    method: 'post',
    data
  })
}
// 查询待处理的业务数量清单
export function queryWarningInfoLobCount(data) {
  return request({
    url: `${URL.sys.queryWarningInfoLobCount}`,
    method: 'post',
    data
  })
}
// 查询待处理的节点数量清单
export function queryWarningInfoTrackingCount(data) {
  return request({
    url: `${URL.sys.queryWarningInfoTrackingCount}`,
    method: 'post',
    data
  })
}
// 获取首页预警，已处理、忽略消息
export function handle(data) {
  return request({
    url: `${URL.sys.handle}`,
    method: 'post',
    data
  })
}

// 按照业务类型统计模板及其节点数量
export function getLobTemplateAndNodeCount(params) {
  return request({
    url: `${URL.sys.getLobTemplateAndNodeCount}`,
    method: 'get',
    params
  })
}

// sop工作任务 优先级 条件项下拉
export function getSopWtPriorityConditionEnums(params) {
  return request({
    url: `${URL.sys.getSopWtPriorityConditionEnums}`,
    method: 'get',
    params
  })
}

// 是否展示sop工作任务看板
export function showSopWtDashBoard(params) {
  return request({
    url: `${URL.sys.showSopWtDashBoard}`,
    method: 'get',
    params
  })
}

// sop工作任务 lobs
export function getLobsWt(params) {
  return request({
    url: `${URL.sys.getLobsWt}`,
    method: 'get',
    params
  })
}

// sop工作任务 模板
export function getTemplatesWt(params) {
  return request({
    url: `${URL.sys.getTemplatesWt}`,
    method: 'get',
    params
  })
}

// sop工作任务看板 获取sop节点各个【优先级】下job票数
export function getNodePriorityJobCountWt(data) {
  return request({
    url: `${URL.sys.getNodePriorityJobCountWt}`,
    method: 'post',
    data
  })
}

// sop工作任务看板 job信息
export function getPriorityJobsWt(data) {
  return request({
    url: `${URL.sys.getPriorityJobsWt}`,
    method: 'post',
    data
  })
}
